import React, { FC, PropsWithChildren } from 'react'

import { ErrorPage } from 'ErrorPage'
import { Route } from 'react-router'
import { Store } from 'redux'

import { InstrumentedErrorBoundary } from '@library/browser-errors'
import { BROWSER_ERROR_KEYS } from '@library/observability/browser'

import { client } from 'config/routes'
import { MainLayout } from 'layouts/MainLayout'
import { instrumentedOnEnter } from 'routes/Menu/utils/instrumentation'
import { checkValidSession } from 'utils/routes'

import { OrderConfirmationWrapper } from './OrderConfirmationWrapper'

const ErrorPageWrapper = () => (
  <MainLayout>
    <ErrorPage />
  </MainLayout>
)

const OrderConfirmation: FC<PropsWithChildren<any>> = (props) => (
  <InstrumentedErrorBoundary
    errorKey={BROWSER_ERROR_KEYS.UNEXPECTED_ORDER_CONFIRMATION_PAGE_ERROR}
    fallback={ErrorPageWrapper}
  >
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <OrderConfirmationWrapper {...props} />
  </InstrumentedErrorBoundary>
)

const safeCheckValidSession = (store: Store<any, any>, home: string) =>
  instrumentedOnEnter(
    checkValidSession(store, home, true),
    BROWSER_ERROR_KEYS.ORDER_CONFIRMATION_AUTHENTICATION_CHECK_ERROR,
    {},
  )

const OrderConfirmationRoute = (store: Store<any, any>) => {
  const { orderConfirmation, home } = client

  return (
    <Route
      path={orderConfirmation}
      component={OrderConfirmation}
      onEnter={safeCheckValidSession(store, home)}
    />
  )
}

export { OrderConfirmationRoute }
